const React = require('react');
const { MarcomThemeProvider } = require('./src/components/MarcomThemeProvider');
const { initSegment, initImpactRadius } = require('./static/js/initialScripts');
const { initNewRelicBrowserMonitoring } = require('./static/js/newrelic');

/**
 * Implement Gatsby's Browser APIs in this file.
 **/
require('intersection-observer');
const { segment } = require('./static/js/joy');
const { initFallback } = require('./src/utils/imageFallback');

initFallback(segment);

let isInitialized = false;
exports.onInitialClientRender = () => {
  const global = window;
  if ((global.location.search || '').replace('feature.marcom=', '').includes('feature.')) {
    // only load the query string parsing library
    // if there is a query string in the url
    require(['./src/gatsby-browser/query-string-features'], qs => {
      qs.init();
    });
  }
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  global.scrollTo(0, 0);
  setTimeout(() => {
    isInitialized = true;
  }, 100);
};

exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  return isInitialized;
};

exports.onRouteUpdate = ({ location, prevLocation }) => {
  prevLocation = prevLocation ? prevLocation.href : '';
  segment.sendTelemetryPageView(location, prevLocation);
};

exports.onClientEntry = () => {
  if (global) {
    global.addEventListener('load', event => {
      global.localStorage.setItem('cookiesBannerCosed', 'no');
    });
    if (global.localStorage.getItem('cookiesStatus') !== 'declined') {
      initNewRelicBrowserMonitoring();
      initSegment();
      segment.initTelemetry();
      segment.setDestinationHostname();
      initImpactRadius();
      global.addEventListener('load', event => {
        const addElement = (type, src, alt = '') => {
          const s = document.createElement(type);
          s.src = src;
          if ('script' === type) {
            s.type = `text/javascript`;
          } else {
            s.alt = alt;
            s.width = 1;
            s.height = 1;
            s.hidden = true;
          }
          const bodyEl = document?.getElementsByTagName(`body`)?.[0];
          if (bodyEl) {
            bodyEl.prepend(s);
          }
        };
        addElement('script', 'https://polaris.truevaultcdn.com/static/dns-link.js');
        // I Heart Radio Conversion Pixel for [content]- DO NOT MODIFY
        addElement(
          'img',
          'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=content&pixid=aad0d74e-06ee-4d0e-8000-408c8e31396a',
          'conversion pixel - content'
        );
        addElement('img', 'https://ct.pinterest.com/v3/?tid=2617606439718&noscript=1');
      });
    }
  }
};

exports.wrapRootElement = ({ element }) => <MarcomThemeProvider>{element}</MarcomThemeProvider>;
